import { render, staticRenderFns } from "./listpds.vue?vue&type=template&id=635e9f1a&scoped=true"
import script from "./listpds.vue?vue&type=script&lang=js"
export * from "./listpds.vue?vue&type=script&lang=js"
import style0 from "./listpds.vue?vue&type=style&index=0&id=635e9f1a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e9f1a",
  null
  
)

export default component.exports